import { render, staticRenderFns } from "./AddLocationModal.vue?vue&type=template&id=06d640ba&scoped=true&"
import script from "./AddLocationModal.vue?vue&type=script&lang=js&"
export * from "./AddLocationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLocationModal.vue?vue&type=style&index=0&id=06d640ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d640ba",
  null
  
)

export default component.exports